'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('../settings/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    boxShadow: _styles2.default.depthShadows[0],
    borderRadius: '4px',
    overflow: 'hidden'
  }
};
module.exports = exports.default;